export const INSURANCE_WEBSITE_URL = 'https://www.travelinsurance.com/?utm_source=pap&a_aid=62d8f6875a6f0'
export const CAR_RENT_WEBSITE_URL = 'https://www.discovercars.com/?a_aid=Trava'
